import type {LineRange} from '@github-ui/diffs/types'

export class DiffAddCommentButtonClickedEvent extends Event {
  endLineNumber: number
  endOrientation: string
  filePath: string
  startOrientation: string | undefined
  startLineNumber: number | undefined
  constructor(lineRange: LineRange, filePath: string) {
    super('DiffAddCommentButtonClickedEvent', {
      bubbles: true,
      cancelable: true,
      composed: true,
    })

    this.startLineNumber = lineRange.startLineNumber
    this.endLineNumber = lineRange.endLineNumber
    this.startOrientation = lineRange.startOrientation
    this.endOrientation = lineRange.endOrientation
    this.filePath = filePath
  }
}

export class DiffSelectedLineEvent extends Event {
  endLineNumber: number
  endOrientation: string
  filePath: string
  startOrientation: string | undefined
  startLineNumber: number | undefined
  constructor(lineRange: LineRange, filePath: string) {
    super('DiffSelectedLineEvent', {
      bubbles: true,
      cancelable: true,
      composed: true,
    })

    this.startLineNumber = lineRange.startLineNumber
    this.endLineNumber = lineRange.endLineNumber
    this.startOrientation = lineRange.startOrientation
    this.endOrientation = lineRange.endOrientation
    this.filePath = filePath
  }
}
